module.exports = __webpack_public_path__ + "static/media/loader.04e076f4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assests/images/loader.gif
// module id = 748
// module chunks = 0